/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Offering_OfferingContext_ManagerPartsFragment = {
  readonly __typename?: 'ManagerFull';
  readonly id: string;
  readonly firmName: string;
  readonly firmNameAbbreviation?: string | null;
  readonly cmgEntityKey: string;
};

export type Offering_OfferingContext_EligibleBndAgentPartsFragment = {
  readonly __typename?: 'ManagerFull';
  readonly id: string;
  readonly firmName: string;
  readonly firmNameAbbreviation?: string | null;
  readonly cmgEntityKey: string;
};

export type Offering_OfferingContext_OfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly type: Types.OfferingType;
  readonly pricingInstrumentId?: string | null;
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly region?: string | null;
  }>;
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly eligibleBillingAndDeliveryAgents?: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly id: string;
      readonly firmName: string;
      readonly firmNameAbbreviation?: string | null;
      readonly cmgEntityKey: string;
    }> | null;
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly id: string;
      readonly firmName: string;
      readonly firmNameAbbreviation?: string | null;
      readonly cmgEntityKey: string;
    }>;
  } | null;
};

export type Offering_OfferingContext_PrivateOfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly type: Types.OfferingType;
  readonly pricingInstrumentId?: string | null;
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly region?: string | null;
  }>;
};

export type Offering_OfferingContextQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  hasOfferingPrivateAccess: Types.Scalars['Boolean']['input'];
  includePrivatePlacementOfferings: Types.Scalars['Boolean']['input'];
}>;

export type Offering_OfferingContextQuery = {
  readonly __typename?: 'Query';
  readonly privateOfferings?: {
    readonly __typename?: 'PrivateOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly type: Types.OfferingType;
      readonly pricingInstrumentId?: string | null;
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly region?: string | null;
      }>;
    }> | null;
  } | null;
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly pricingInstrumentId?: string | null;
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly region?: string | null;
      }>;
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly eligibleBillingAndDeliveryAgents?: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly firmName: string;
          readonly firmNameAbbreviation?: string | null;
          readonly cmgEntityKey: string;
        }> | null;
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly firmName: string;
          readonly firmNameAbbreviation?: string | null;
          readonly cmgEntityKey: string;
        }>;
      } | null;
    }> | null;
  } | null;
};

export type Offering_OfferingContext_OfferingPublishedSubscriptionVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type Offering_OfferingContext_OfferingPublishedSubscription = {
  readonly __typename?: 'Subscription';
  readonly offeringPublished: {
    readonly __typename?: 'OfferingPublished';
    readonly offeringId: string;
  };
};

export type Offering_OfferingHeader_OfferingFilingsPartsFragment = {
  readonly __typename?: 'FilingFull';
  readonly filingType: Types.FilingType;
  readonly offerPrice?: number | null;
  readonly ipoRangeLow?: number | null;
  readonly ipoRangeHigh?: number | null;
  readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
  readonly sizeInCurrency?: number | null;
  readonly parValue?: number | null;
  readonly couponTalkHigh?: number | null;
  readonly couponTalkLow?: number | null;
  readonly premium?: number | null;
  readonly coupon?: number | null;
  readonly premiumTalkHigh?: number | null;
  readonly premiumTalkLow?: number | null;
};

export type Offering_OfferingHeader_OfferingFollowOnPricingPartsFragment = {
  readonly __typename?: 'FollowOnPricingFull';
  readonly lastTradeBeforeFiling?: number | null;
  readonly lastTradeBeforeOffer?: number | null;
  readonly lastTradeBeforeLaunch?: number | null;
  readonly reOfferLow?: number | null;
  readonly reOfferHigh?: number | null;
};

export type Offering_OfferingHeader_OfferingTermsPartsFragment = {
  readonly __typename?: 'TermsFull';
  readonly filings: ReadonlyArray<{
    readonly __typename?: 'FilingFull';
    readonly filingType: Types.FilingType;
    readonly offerPrice?: number | null;
    readonly ipoRangeLow?: number | null;
    readonly ipoRangeHigh?: number | null;
    readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
    readonly sizeInCurrency?: number | null;
    readonly parValue?: number | null;
    readonly couponTalkHigh?: number | null;
    readonly couponTalkLow?: number | null;
    readonly premium?: number | null;
    readonly coupon?: number | null;
    readonly premiumTalkHigh?: number | null;
    readonly premiumTalkLow?: number | null;
  }>;
  readonly followOnPricing?: {
    readonly __typename?: 'FollowOnPricingFull';
    readonly lastTradeBeforeFiling?: number | null;
    readonly lastTradeBeforeOffer?: number | null;
    readonly lastTradeBeforeLaunch?: number | null;
    readonly reOfferLow?: number | null;
    readonly reOfferHigh?: number | null;
  } | null;
  readonly privatePlacementTerms?: {
    readonly __typename?: 'PrivatePlacementTermsFull';
    readonly sizeShares?: number | null;
  } | null;
};

export type Offering_OfferingHeader_OfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly status: Types.OfferingStatus;
  readonly stage: Types.OfferingStage;
  readonly isAuthor: boolean;
  readonly type: Types.OfferingType;
  readonly isInternal: boolean;
  readonly sizeInShares?: number | null;
  readonly pricingCurrencyCode: string;
  readonly pricingInstrumentId?: string | null;
  readonly isWallCrossEnabled?: boolean | null;
  readonly issuer: {
    readonly __typename?: 'IssuerFull';
    readonly name: string;
    readonly sector?: Types.Sector | null;
  };
  readonly security: { readonly __typename?: 'SecurityFull'; readonly type: Types.SecurityType };
  readonly terms: {
    readonly __typename?: 'TermsFull';
    readonly filings: ReadonlyArray<{
      readonly __typename?: 'FilingFull';
      readonly filingType: Types.FilingType;
      readonly offerPrice?: number | null;
      readonly ipoRangeLow?: number | null;
      readonly ipoRangeHigh?: number | null;
      readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
      readonly sizeInCurrency?: number | null;
      readonly parValue?: number | null;
      readonly couponTalkHigh?: number | null;
      readonly couponTalkLow?: number | null;
      readonly premium?: number | null;
      readonly coupon?: number | null;
      readonly premiumTalkHigh?: number | null;
      readonly premiumTalkLow?: number | null;
    }>;
    readonly followOnPricing?: {
      readonly __typename?: 'FollowOnPricingFull';
      readonly lastTradeBeforeFiling?: number | null;
      readonly lastTradeBeforeOffer?: number | null;
      readonly lastTradeBeforeLaunch?: number | null;
      readonly reOfferLow?: number | null;
      readonly reOfferHigh?: number | null;
    } | null;
    readonly privatePlacementTerms?: {
      readonly __typename?: 'PrivatePlacementTermsFull';
      readonly sizeShares?: number | null;
    } | null;
  };
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly countryCode?: string | null;
  }>;
};

export type Offering_OfferingHeaderQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  hasOfferingReadPermission: Types.Scalars['Boolean']['input'];
  includePrivatePlacementOfferings: Types.Scalars['Boolean']['input'];
}>;

export type Offering_OfferingHeaderQuery = {
  readonly __typename?: 'Query';
  readonly privateOfferings?: {
    readonly __typename?: 'PrivateOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly status: Types.OfferingStatus;
      readonly stage: Types.OfferingStage;
      readonly isAuthor: boolean;
      readonly type: Types.OfferingType;
      readonly isInternal: boolean;
      readonly sizeInShares?: number | null;
      readonly pricingCurrencyCode: string;
      readonly pricingInstrumentId?: string | null;
      readonly isWallCrossEnabled?: boolean | null;
      readonly issuer: {
        readonly __typename?: 'IssuerFull';
        readonly name: string;
        readonly sector?: Types.Sector | null;
      };
      readonly security: {
        readonly __typename?: 'SecurityFull';
        readonly type: Types.SecurityType;
      };
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly filingType: Types.FilingType;
          readonly offerPrice?: number | null;
          readonly ipoRangeLow?: number | null;
          readonly ipoRangeHigh?: number | null;
          readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
          readonly sizeInCurrency?: number | null;
          readonly parValue?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly couponTalkLow?: number | null;
          readonly premium?: number | null;
          readonly coupon?: number | null;
          readonly premiumTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
        }>;
        readonly followOnPricing?: {
          readonly __typename?: 'FollowOnPricingFull';
          readonly lastTradeBeforeFiling?: number | null;
          readonly lastTradeBeforeOffer?: number | null;
          readonly lastTradeBeforeLaunch?: number | null;
          readonly reOfferLow?: number | null;
          readonly reOfferHigh?: number | null;
        } | null;
        readonly privatePlacementTerms?: {
          readonly __typename?: 'PrivatePlacementTermsFull';
          readonly sizeShares?: number | null;
        } | null;
      };
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly countryCode?: string | null;
      }>;
    }> | null;
  } | null;
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly status: Types.OfferingStatus;
      readonly stage: Types.OfferingStage;
      readonly isAuthor: boolean;
      readonly type: Types.OfferingType;
      readonly isInternal: boolean;
      readonly sizeInShares?: number | null;
      readonly pricingCurrencyCode: string;
      readonly pricingInstrumentId?: string | null;
      readonly isWallCrossEnabled?: boolean | null;
      readonly issuer: {
        readonly __typename?: 'IssuerFull';
        readonly name: string;
        readonly sector?: Types.Sector | null;
      };
      readonly security: {
        readonly __typename?: 'SecurityFull';
        readonly type: Types.SecurityType;
      };
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly filingType: Types.FilingType;
          readonly offerPrice?: number | null;
          readonly ipoRangeLow?: number | null;
          readonly ipoRangeHigh?: number | null;
          readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
          readonly sizeInCurrency?: number | null;
          readonly parValue?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly couponTalkLow?: number | null;
          readonly premium?: number | null;
          readonly coupon?: number | null;
          readonly premiumTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
        }>;
        readonly followOnPricing?: {
          readonly __typename?: 'FollowOnPricingFull';
          readonly lastTradeBeforeFiling?: number | null;
          readonly lastTradeBeforeOffer?: number | null;
          readonly lastTradeBeforeLaunch?: number | null;
          readonly reOfferLow?: number | null;
          readonly reOfferHigh?: number | null;
        } | null;
        readonly privatePlacementTerms?: {
          readonly __typename?: 'PrivatePlacementTermsFull';
          readonly sizeShares?: number | null;
        } | null;
      };
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly countryCode?: string | null;
      }>;
    }> | null;
  } | null;
};

export const Offering_OfferingContext_EligibleBndAgentPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_EligibleBndAgentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingContext_ManagerPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_ManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingContext_OfferingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eligibleBillingAndDeliveryAgents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'Offering_OfferingContext_EligibleBndAgentParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Offering_OfferingContext_ManagerParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_ManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_EligibleBndAgentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingContext_PrivateOfferingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_PrivateOfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingHeader_OfferingFilingsPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingHeader_OfferingFollowOnPricingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeFiling' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingHeader_OfferingTermsPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingTermsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privatePlacementTerms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sizeShares' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeFiling' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingHeader_OfferingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingTermsParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isWallCrossEnabled' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeFiling' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingTermsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privatePlacementTerms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sizeShares' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Offering_OfferingContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Offering_OfferingContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasOfferingPrivateAccess' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'hasOfferingPrivateAccess' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'Offering_OfferingContext_PrivateOfferingParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Offering_OfferingContext_OfferingParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_ManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_EligibleBndAgentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eligibleBillingAndDeliveryAgents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'Offering_OfferingContext_EligibleBndAgentParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Offering_OfferingContext_ManagerParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingContext_PrivateOfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOffering_OfferingContextQuery__
 *
 * To run a query within a React component, call `useOffering_OfferingContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffering_OfferingContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffering_OfferingContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasOfferingPrivateAccess: // value for 'hasOfferingPrivateAccess'
 *      includePrivatePlacementOfferings: // value for 'includePrivatePlacementOfferings'
 *   },
 * });
 */
export function useOffering_OfferingContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    Offering_OfferingContextQuery,
    Offering_OfferingContextQueryVariables
  > &
    ({ variables: Offering_OfferingContextQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Offering_OfferingContextQuery, Offering_OfferingContextQueryVariables>(
    Offering_OfferingContextDocument,
    options
  );
}
export function useOffering_OfferingContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Offering_OfferingContextQuery,
    Offering_OfferingContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Offering_OfferingContextQuery, Offering_OfferingContextQueryVariables>(
    Offering_OfferingContextDocument,
    options
  );
}
// @ts-ignore
export function useOffering_OfferingContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Offering_OfferingContextQuery,
    Offering_OfferingContextQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Offering_OfferingContextQuery,
  Offering_OfferingContextQueryVariables
>;
export function useOffering_OfferingContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Offering_OfferingContextQuery,
        Offering_OfferingContextQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Offering_OfferingContextQuery | undefined,
  Offering_OfferingContextQueryVariables
>;
export function useOffering_OfferingContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Offering_OfferingContextQuery,
        Offering_OfferingContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Offering_OfferingContextQuery,
    Offering_OfferingContextQueryVariables
  >(Offering_OfferingContextDocument, options);
}
export type Offering_OfferingContextQueryHookResult = ReturnType<
  typeof useOffering_OfferingContextQuery
>;
export type Offering_OfferingContextLazyQueryHookResult = ReturnType<
  typeof useOffering_OfferingContextLazyQuery
>;
export type Offering_OfferingContextSuspenseQueryHookResult = ReturnType<
  typeof useOffering_OfferingContextSuspenseQuery
>;
export type Offering_OfferingContextQueryResult = Apollo.QueryResult<
  Offering_OfferingContextQuery,
  Offering_OfferingContextQueryVariables
>;
export const Offering_OfferingContext_OfferingPublishedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'Offering_OfferingContext_OfferingPublished' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offeringPublished' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offeringId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'offeringId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOffering_OfferingContext_OfferingPublishedSubscription__
 *
 * To run a query within a React component, call `useOffering_OfferingContext_OfferingPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOffering_OfferingContext_OfferingPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffering_OfferingContext_OfferingPublishedSubscription({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useOffering_OfferingContext_OfferingPublishedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Offering_OfferingContext_OfferingPublishedSubscription,
    Offering_OfferingContext_OfferingPublishedSubscriptionVariables
  > &
    (
      | {
          variables: Offering_OfferingContext_OfferingPublishedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Offering_OfferingContext_OfferingPublishedSubscription,
    Offering_OfferingContext_OfferingPublishedSubscriptionVariables
  >(Offering_OfferingContext_OfferingPublishedDocument, options);
}
export type Offering_OfferingContext_OfferingPublishedSubscriptionHookResult = ReturnType<
  typeof useOffering_OfferingContext_OfferingPublishedSubscription
>;
export type Offering_OfferingContext_OfferingPublishedSubscriptionResult =
  Apollo.SubscriptionResult<Offering_OfferingContext_OfferingPublishedSubscription>;
export const Offering_OfferingHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Offering_OfferingHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hasOfferingReadPermission' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'hasOfferingReadPermission' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isExecutingOnPlatform' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeFiling' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingTermsParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingFilingsParts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'Offering_OfferingHeader_OfferingFollowOnPricingParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privatePlacementTerms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sizeShares' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAuthor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Offering_OfferingHeader_OfferingTermsParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isWallCrossEnabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOffering_OfferingHeaderQuery__
 *
 * To run a query within a React component, call `useOffering_OfferingHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffering_OfferingHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffering_OfferingHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasOfferingReadPermission: // value for 'hasOfferingReadPermission'
 *      includePrivatePlacementOfferings: // value for 'includePrivatePlacementOfferings'
 *   },
 * });
 */
export function useOffering_OfferingHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    Offering_OfferingHeaderQuery,
    Offering_OfferingHeaderQueryVariables
  > &
    ({ variables: Offering_OfferingHeaderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Offering_OfferingHeaderQuery, Offering_OfferingHeaderQueryVariables>(
    Offering_OfferingHeaderDocument,
    options
  );
}
export function useOffering_OfferingHeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Offering_OfferingHeaderQuery,
    Offering_OfferingHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Offering_OfferingHeaderQuery, Offering_OfferingHeaderQueryVariables>(
    Offering_OfferingHeaderDocument,
    options
  );
}
// @ts-ignore
export function useOffering_OfferingHeaderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Offering_OfferingHeaderQuery,
    Offering_OfferingHeaderQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Offering_OfferingHeaderQuery,
  Offering_OfferingHeaderQueryVariables
>;
export function useOffering_OfferingHeaderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Offering_OfferingHeaderQuery,
        Offering_OfferingHeaderQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Offering_OfferingHeaderQuery | undefined,
  Offering_OfferingHeaderQueryVariables
>;
export function useOffering_OfferingHeaderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Offering_OfferingHeaderQuery,
        Offering_OfferingHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Offering_OfferingHeaderQuery,
    Offering_OfferingHeaderQueryVariables
  >(Offering_OfferingHeaderDocument, options);
}
export type Offering_OfferingHeaderQueryHookResult = ReturnType<
  typeof useOffering_OfferingHeaderQuery
>;
export type Offering_OfferingHeaderLazyQueryHookResult = ReturnType<
  typeof useOffering_OfferingHeaderLazyQuery
>;
export type Offering_OfferingHeaderSuspenseQueryHookResult = ReturnType<
  typeof useOffering_OfferingHeaderSuspenseQuery
>;
export type Offering_OfferingHeaderQueryResult = Apollo.QueryResult<
  Offering_OfferingHeaderQuery,
  Offering_OfferingHeaderQueryVariables
>;

import { makeMockResponse } from '../../../../graphql/mock-response';

export const makeOffering_OfferingContextMockResponse = makeMockResponse<
  Offering_OfferingContextQueryVariables,
  Offering_OfferingContextQuery
>(Offering_OfferingContextDocument);

export const makeOffering_OfferingHeaderMockResponse = makeMockResponse<
  Offering_OfferingHeaderQueryVariables,
  Offering_OfferingHeaderQuery
>(Offering_OfferingHeaderDocument);
